<template>
  <!-- <draggable> -->
  <div
    class="Table"
    :data-ratio="table.ratio"
    :data-mode="table.mode"
    :style="{
      transform: `scale(${scale}) translateX(${currentX}px) translateY(${currentY}px)`
    }"
    @mousedown="onStart"
  >
    <div class="panel" @dblclick="selectPanelImage">
      <a v-if="table.youtubeId" class="closeYT" @click="closeYT">youtubeを閉じる</a>
      <div class="youtube" v-if="table.youtubeId">
        <youtube
          width="100%"
          height="100%"
          :video-id="table.youtubeId"
          :player-vars="{ autoplay: 1, resize: true }"
          ref="youtube"
          @playing="playing"
        />
      </div>
      <img v-if="table.backgroundImageKey" :src="src(table.backgroundImageKey)" draggable="false" alt="">
      <img v-if="table.imageKey" class="cover" :src="src(table.imageKey)" draggable="false" alt="">
    </div>
    <div class="board">
      <slot />
    </div>
    <div class="step">
      <slot name="step" />
    </div>
  </div>
  <!-- </draggable> -->
</template>
<script>
import draggable from '../common/draggable'
export default {
  components: { draggable },
  data() {
    return {
      startX: 0,
      startY: 0,
      touchX: 0,
      touchY: 0,
      currentX: 0,
      currentY: 0,
      isChanged: false,
      isNotClick: false,
      isDragging: false
    }
  },
  computed: {
    scale() {
      return this.$store.getters['local/tableScale']
    },
    table() {
      return this.$store.getters['room/table']
    },
    muted() {
      return this.$store.getters['local/muted']
    },
    // tableX() {
    //   return this.$store.getters['memo/tableX']
    // },
    // tableY() {
    //   return this.$store.getters['memo/tableY']
    // },
    src() {
      return this.$store.getters['images/getSrc']
    },
    role() {
      return this.$store.getters['local/role']
    },
    youtubeId() {
      return this.$youtube.getIdFromUrl(this.table.youtubeURL)
    }
  },
  methods: {
    onStart(e) {
      const { currentX, currentY } = this.$data
      this.$data.startX = ~~currentX
      this.$data.startY = ~~currentY
      this.$data.touchX = e.clientX
      this.$data.touchY = e.clientY
      this.$data.isChanged = false
      this.$data.isNotClick = false
      this.$data.isDragging = true
      this.enable()
    },
    onMove(e) {
      const { isDragging } = this.$data
      const { scale } = this
      if (isDragging) {
        const {
          touchX,
          touchY,
          startX,
          startY,
          currentX,
          currentY
        } = this.$data
        const diffX = e.clientX / scale - touchX / scale
        const diffY = e.clientY / scale - touchY / scale

        this.$data.currentX = startX + diffX
        this.$data.currentY = startY + diffY

        // this.$store.commit('memo/setTablePos', [startX + diffX, startY + diffY])

        // this.$data.isChanged = true
        this.$data.isNotClick = Math.abs(diffX) > 2
        clearTimeout(this.timer)
        this.timer = setTimeout(() => {
          this.onEnd()
        }, 1500)
        e.preventDefault();
      }
    },
    onEnd() {
      // const { currentX, currentY, isChanged } = this.$data
      this.isDragging = false
      this.disable()
      // if (isChanged) this.$emit('change', currentX, currentY, currentW, currentH, currentAngle)
    },
    selectPanelImage() {
      if (this.role <= 5) return
      this.$store.commit('selectors/open', {
        tags: ['scenes'],
        action: 'room/$set',
        context: { key: 'tableImageKey' }
      })
    },
    enable() {
      if (window) {
        window.addEventListener('mousemove', this.onMove)
        window.addEventListener('mouseup', this.onEnd)
      }
    },
    disable() {
      this.isDragging = false
      if (window) {
        window.removeEventListener('mousemove', this.onMove)
        window.removeEventListener('mouseup', this.onEnd)
      }
    },
    closeYT() {
      this.$store.dispatch('room/$set', {
        key: 'youtubeId',
        value: ''
      })
    },
    playing() {
      if (this.$refs.youtube) {
        this.$refs.youtube.player.setVolume(10)
        if (this.muted) {
          this.$refs.youtube.player.mute()
        }
      }
    }
  },
  watch: {
    muted() {
      if (this.$refs.youtube) {
        if (this.muted) {
          this.$refs.youtube.player.mute()
        } else {
          this.$refs.youtube.player.unMute()
        }
      }
    }
  }
}
</script>

<style scoped>
.Table {
  width: 960px;
  height: 540px;
  position: relative;
  /*height: 720px;*/
  /*height: 960px;*/
  /* background-color: #222; */
  background-size: 100% 100%;
  background-repeat: no-repeat;
  background-position: 50% 50%;
  transform-style: preserve-3d;
  perspective: 3000px;
  /*box-shadow: 0 0 20px rgba(0, 0, 0, 0.8);*/
}
.Table[data-ratio="a5"] {
  width: 380px;
  height: 540px;
}
.Table[data-ratio="1:1"] {
  width: 540px;
  height: 540px;
}
.Table[data-ratio="4:3"] {
  width: 720px;
  height: 540px;
}
.Table[data-ratio="16:9"] {
  width: 960px;
  height: 540px;
}
.Table[data-mode="3d"] .panel {
  transform: rotateX(60deg);
}
.Table .panel {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  transform-origin: bottom;
  /* box-shadow: 0 0 20px rgba(0, 0, 0, 0.8); */
  transition: all 300ms ease-out;
}
.Table .panel img {
  width: 100%;
  height: 100%;
  user-select: none;
}
.Table .panel .cover {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
}
.Table .board {
  position: absolute;
  top: 50%;
  left: 50%;
  width: 0;
  height: 0;
  z-index: 1;
}
.Table .step {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  width: 100%;
  height: 0;
}
.Table .controls {
  display: flex;
  padding: 5px;
  position: absolute;
  top: 100%;
  left: 50%;
  transform: translateX(-50%);
}
.Table .controls a {
  font-size: 10px;
  color: #fff;
}
.Table .controls a + a {
  margin-left: 5px;
}
.closeYT {
  padding: 4px 8px;
  position: absolute;
  bottom: 100%;
  left: 0;
  background: rgba(0, 0, 0, 0.6);
  color: #fff;
  font-size: 12px;
  cursor: pointer;
  z-index: 99;
}
</style>
